export const STORE_COMPONENT_BY_TYPE = {
  dropdownlist: 'BaseDatalistStore',
  multiselect: 'BaseDatalistStore',
  status: 'BaseDatalistStore',
  cameras: 'CamerasStore',
  number: 'NumberInput',
  info: 'InfoFieldStore',
  label: 'InfoFieldStore',
  checkbox: 'CheckboxStore',
  checkboxlist: 'ChoiceListStore',
  radiobuttonlist: 'ChoiceListStore',
  sqlchoosen: 'SqlSelectStore',
  textarea: 'BaseTextareaStore',
  richtext: 'RichTextStore',
  gps: 'GpsStore',
  date: 'DateTimeStore',
  date_interval: 'DateTimeStore',
  datetime: 'DateTimeStore',
  datetime_interval: 'DateTimeStore',
  time: 'DateTimeStore',
  time_interval: 'DateTimeStore',
  'datetime-local': 'DateTimeStore',
  rating: 'RatingStore',
  slider: 'BaseRangeStore',
  link: 'LinkStore',
  wpaint: 'PaintStore',
  signature: 'SignatureStore',
  jsoneditor: 'JsonEditorStore',
  password: 'PasswordFieldStore',
  comment: 'CommentStore',
  tag: 'TagFieldStore',
  captcha: 'Captcha',
  expressioneditor: 'ExpressionEditorStore',
}

export const DEFAULT_STORE_COMPONENT = 'BaseInputStore'

export const BASE_COMPONENT_BY_TYPE = {
  dropdownlist: 'BaseDatalist',
  multiselect: 'BaseDatalist',
  status: 'BaseDatalist',
  cameras: 'Cameras',
  number: 'NumberInput',
  info: 'InfoField',
  label: 'InfoField',
  checkbox: 'Checkbox',
  checkboxlist: 'ChoiceList',
  radiobuttonlist: 'ChoiceList',
  sqlchoosen: 'SqlSelect',
  textarea: 'BaseInput',
  richtext: 'RichText',
  gps: 'Gps',
  date: 'DateTime',
  date_interval: 'DateTime',
  datetime: 'DateTime',
  datetime_interval: 'DateTime',
  time: 'DateTime',
  time_interval: 'DateTime',
  'datetime-local': 'DateTime',
  rating: 'Rating',
  slider: 'BaseRange',
  wpaint: 'Paint',
  signature: 'Signature',
  jsoneditor: 'JsonEditor',
  password: 'PasswordField',
  comment: 'Comment',
  tag: 'TagField',
  captcha: 'Captcha',
  expressioneditor: 'ExpressionEditor',
}

export const DEFAULT_BASE_COMPONENT = 'BaseInput'
